import { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { Loader2, LogIn } from "lucide-react";
import { errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const Brand = () => (
  <div className="mb-8 flex items-center gap-2.5" data-testid="login-brand">
    <span className="grid h-10 w-10 place-items-center rounded-xl bg-indigo-600 font-display text-base font-extrabold text-white">AS</span>
    <span className="font-display text-xl font-extrabold tracking-tight">Ace Sales CRM</span>
  </div>
);

const Field = ({ label, testid, ...props }) => (
  <label className="block"><span className="field-label">{label}</span>
    <input data-testid={testid} className="inp h-11" {...props} />
  </label>
);

export default function LoginPage() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  if (user) return <Navigate to="/" replace />;

  const submit = async (e) => {
    e.preventDefault();
    if (!username.trim()) return setError("Username is required");
    if (!password) return setError("Password is required");
    setBusy(true);
    try {
      await login(username.trim(), password);
      navigate("/", { replace: true });
    } catch (err) {
      setError(errMsg(err, "Sign-in failed, please try again"));
      setBusy(false);
    }
  };

  return (
    <div className="grid min-h-screen place-items-center bg-[#0B0F17] px-4 text-slate-50" data-testid="login-page">
      <div className="w-full max-w-sm animate-[fadeIn_300ms_ease-out]">
        <Brand />
        <h1 className="font-display text-2xl font-extrabold tracking-tight sm:text-3xl">Sign in</h1>
        <p className="mb-6 mt-1 text-sm text-slate-400">Use the account your admin created for you.</p>
        <form onSubmit={submit} data-testid="login-form" className="space-y-4 rounded-2xl border border-slate-800 bg-slate-900 p-5">
          <Field label="Username" testid="login-username-input" value={username} autoComplete="username" autoCapitalize="none"
            onChange={(e) => { setUsername(e.target.value); setError(""); }} />
          <Field label="Password" testid="login-password-input" type="password" value={password} autoComplete="current-password"
            onChange={(e) => { setPassword(e.target.value); setError(""); }} />
          {error && <p data-testid="login-error" role="alert" className="field-error text-sm">{error}</p>}
          <button type="submit" disabled={busy} data-testid="login-submit-btn" className="btn-primary h-11 w-full">
            {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <LogIn className="h-4 w-4" />} Sign in
          </button>
        </form>
      </div>
    </div>
  );
}
